export default __webpack_public_path__ + "static/outdoors-c92053a9e405054f7121ed94adbf67e6.webp";